import React, { useEffect, useState } from 'react'

import {
    Typography, Paper, Pagination, Stack, Grid, useMediaQuery,
    IconButton, Button, Card, CardMedia, Popper, ClickAwayListener, List, ListItem, Link, TextField, InputAdornment, CircularProgress
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';

import { ReactComponent as Empty } from "../assets/svg/empty.svg";
import { ReactComponent as Searching } from "../assets/svg/searching_illustration.svg";

import { MoreVert, Search } from '@mui/icons-material';

import Menu from '../components/Menu';
import BottomMenu from '../components/BottomMenu';

import { useDispatch, useSelector } from 'react-redux';
import { getBookmarkedBook, selectBook } from '../redux/actions/bookAction';
import { useHistory } from 'react-router-dom';
export default function Bookmarks() {
    const matches = useMediaQuery('(max-width:1150px)');
    const match = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const book = useSelector((state => state.book))

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
        reserveButton: {
            borderRadius: 5,
            fontSize: 12,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            paddingLeft: 2,
            paddingRight: 2,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
            },
        },
    }
    const [remove, setRemove] = useState(false);
    const [removeAnchor, setRemoveAnchor] = useState();

    const handleOpen = (event) => {
        setRemoveAnchor(event.currentTarget);
        setRemove((prev) => !prev);
    }

    const removeID = remove ? 'simple-popper' : undefined;

    const handleMenu = () => {
        setRemove(false);
    };




    const featuredBook = book.favorites

    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        if (!book.favoritesEmpty && book.favorites.length <= 0) {
            dispatch(getBookmarkedBook());
        } else {
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reserveBook = (bookObject) => (e) => {
        if (bookObject) {
            dispatch(selectBook(bookObject));
            history.push("/reservation")
        }
    }

    const firstIndex = 0;
    const pageSize = 6;
    const [page, setPage] = useState(1);
    const [data, setData] = useState(featuredBook.slice(firstIndex, pageSize));
    const [tempData, setTempData] = useState([])
    const handlePageChange = (event, value) => {
        if (payload.search === "") {
            setPage(value);
            setData(featuredBook.slice(firstIndex + pageSize * (value - 1), pageSize * value));
        } else {
            setPage(value);
            setData(tempData.slice(firstIndex + pageSize * (value - 1), pageSize * value));
        }
    };

    const [payload, setPayload] = useState({
        search: ""
    })

    const handleInputChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
        if (e.target.value !== "") {
            var tempArray = featuredBook.filter(
                (item) =>
                    item.bookTitle.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1 ||
                    item.bookAuthor.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1 ||
                    item.callNumber.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1
            )

            setData(tempArray.slice(firstIndex, pageSize))
            setTempData(tempArray)
        } else {
            setData(featuredBook.slice(firstIndex, pageSize))
        }
    }

    return (
        <Box>
            <SEO title="My Books - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Grid container columns={12} spacing={1}>
                        {!matches && <Grid item xs={12} md={3} sx={{ padding: 3 }}>
                            <Menu />
                        </Grid>}
                        <Grid item xs={12} md={matches ? 12 : 9}>
                            <Box sx={style.scrollableDiv}>
                                <Stack direction="column" sx={{ marginBottom: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "#280707" }}>Bookmarks</Typography>
                                    <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: "#280707" }}>Your favorite books in one place.</Typography>
                                    <TextField
                                        fullWidth
                                        onChange={handleInputChange("search")}
                                        size='small'
                                        sx={{ marginTop: 1 }}
                                        placeholder="Search for your favorite book..."
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }} />
                                </Stack>
                                {!loading ?
                                    <Box>
                                        {data.length > 0 ?
                                            <Box>
                                                <Stack direction="column" spacing={2} sx={{ marginTop: 3 }}>
                                                    <Grid container columns={12} spacing={2}>
                                                        {Array.from(data).map((_, index) => (
                                                            <Grid item xs={12} md={6} key={index}>
                                                                <Card variant="outlined" sx={{ padding: 1 }}>
                                                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                                                        <CardMedia
                                                                            sx={{ width: 80 }}
                                                                            component="img"
                                                                            height="110"
                                                                            image={data[index].bookCover}
                                                                        />
                                                                        <Stack direction="column" spacing={1} alignItems="flex-start">
                                                                            <Typography variant='h6' sx={{ fontWeight: "bold" }}>{data[index].bookTitle}</Typography>
                                                                            <Typography variant='body2' sx={{ fontStyle: "italic" }}>{data[index].bookAuthor}</Typography>
                                                                            <Box sx={{ height: "30%" }} />
                                                                            <Button
                                                                                onClick={reserveBook(data[index])}
                                                                                variant="contained"
                                                                                sx={style.reserveButton} >
                                                                                Reserve
                                                                            </Button>
                                                                        </Stack>
                                                                        <Box component="span" sx={{ flexGrow: 1 }} />
                                                                        <IconButton onClick={handleOpen}>
                                                                            <MoreVert />
                                                                        </IconButton>
                                                                    </Stack>

                                                                </Card>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Stack>
                                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                    <Pagination
                                                        count={Math.ceil(payload.search !== "" ? tempData.length / pageSize : featuredBook.length / pageSize)}
                                                        page={page}
                                                        onChange={handlePageChange}
                                                        variant="outlined"
                                                        shape="rounded"
                                                        sx={{ marginTop: 2 }}
                                                    />
                                                </Box>
                                            </Box>
                                            :
                                            payload.search !== "" ?
                                                <Grid
                                                    container
                                                    columns={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={{ marginTop: matches ? 3 : 0 }}
                                                >
                                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                        <Searching
                                                            style={{
                                                                height: matches ? "68%" : "50%",
                                                                width: matches ? "68%" : "50%"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                        <Typography variant="h5"
                                                            sx={{
                                                                fontWeight: "bold",
                                                                opacity: 0.7,
                                                            }}
                                                        >
                                                            No Found Transactions!
                                                        </Typography>
                                                        <Typography variant="subtitle1"
                                                            sx={{
                                                                fontSize: 15,
                                                                opacity: 0.7,
                                                            }}
                                                        >
                                                            Are you sure the transaction you're looking for is existing? Try looking for more.
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                :
                                                <Grid
                                                    container
                                                    columns={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={{ marginTop: match ? 3 : 0 }}
                                                >
                                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                        <Empty
                                                            style={{
                                                                height: match ? "68%" : "50%",
                                                                width: match ? "68%" : "50%"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                        <Typography variant="h5"
                                                            sx={{
                                                                fontWeight: "bold",
                                                                opacity: 0.7,
                                                            }}
                                                        >
                                                            There are no bookmarks here!
                                                        </Typography>
                                                        <Typography variant="subtitle1"
                                                            sx={{
                                                                fontSize: 15,
                                                                opacity: 0.7,
                                                            }}
                                                        >
                                                            Start exploring the libary collections and look for books you might like.
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                        }
                                    </Box> :
                                    book.favoritesEmpty ?
                                        <Grid
                                            container
                                            columns={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{ marginTop: match ? 3 : 0 }}
                                        >
                                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                <Empty
                                                    style={{
                                                        height: match ? "68%" : "50%",
                                                        width: match ? "68%" : "50%"
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                <Typography variant="h5"
                                                    sx={{
                                                        fontWeight: "bold",
                                                        opacity: 0.7,
                                                    }}
                                                >
                                                    There are no bookmarks here!
                                                </Typography>
                                                <Typography variant="subtitle1"
                                                    sx={{
                                                        fontSize: 15,
                                                        opacity: 0.7,
                                                    }}
                                                >
                                                    Start exploring the libary collections and look for books you might like.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        :
                                        payload.search !== "" ?
                                            <Grid
                                                container
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: matches ? 3 : 0 }}
                                            >
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Searching
                                                        style={{
                                                            height: matches ? "68%" : "50%",
                                                            width: matches ? "68%" : "50%"
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Typography variant="h5"
                                                        sx={{
                                                            fontWeight: "bold",
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        No Found Transactions!
                                                    </Typography>
                                                    <Typography variant="subtitle1"
                                                        sx={{
                                                            fontSize: 15,
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        Are you sure the transaction you're looking for is existing? Try looking for more.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            :
                                            <Grid
                                                container
                                                direction="column"
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: "5%" }}
                                            >
                                                <Grid item xs>
                                                    <CircularProgress />
                                                </Grid>
                                            </Grid>
                                }

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>

            <Box sx={style.footerStyle}>
                {matches ?
                    <BottomMenu />
                    :
                    <Footer />}
            </Box>
            <Popper id={removeID} open={remove} anchorEl={removeAnchor}>
                <ClickAwayListener onClickAway={handleMenu}>
                    <Paper sx={{ marginBottom: 1, marginRight: 2 }}>
                        <List >
                            <ListItem button sx={{ display: "flex", justifyContent: "flex-end" }} >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Link href="/services" sx={{ textDecoration: "none" }}>
                                        <Typography sx={{ color: (theme) => theme.palette.text.primary }} >Remove from bookmarks?</Typography>
                                    </Link>
                                </Stack>
                            </ListItem>

                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </Box>
    )
}
